const createDateFromDMYAndHM = (dateStr, timeStr) => {
  //ДД.ММ.ГГГГ + ЧЧ:ММ → Date

  var dateParts = dateStr.split(".")
  var timeParts = timeStr.split(":")

  return new Date(
    dateParts[2], // year
    dateParts[1] - 1, // month (0-11)
    dateParts[0], // day
    timeParts[0], // hour
    timeParts[1], // minute
    0
  )
}

const  formatDate = (dateString) =>{
  if (!dateString) return '';
  
  var date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  
  var day = String(date.getDate()).padStart(2, '0');
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var year = date.getFullYear();
  
  return day + '.' + month + '.' + year;
}

const formatRemainingTime = (distanceMs) => {
  var totalSeconds = Math.floor(distanceMs / 1000)

  var hours = Math.floor(totalSeconds / 3600)
  var minutes = Math.floor((totalSeconds % 3600) / 60)
  var seconds = totalSeconds % 60

  if (hours > 0) {
    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0")
  } else {
    return String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
  }
}

const startCountdown = (expireDate, selector, onExpire) => {
  let rafId
  let lastUpdate = 0

  const update = (timestamp) => {
    if (timestamp - lastUpdate < 1000) {
      rafId = requestAnimationFrame(update)
      return
    }
    lastUpdate = timestamp

    const now = new Date()
    const distance = expireDate - now

    if (distance <= 0) {
      cancelAnimationFrame(rafId)
      $(selector).html("00:00")
      if (onExpire) onExpire()
      return
    }

    $(selector).html(formatRemainingTime(distance))
    rafId = requestAnimationFrame(update)
  }

  rafId = requestAnimationFrame(update)
  return () => cancelAnimationFrame(rafId)
}



export const CusDate = {
  createDateFromDMYAndHM,
  startCountdown,
  formatDate
}
